
import _ from 'lodash';
import moment from 'moment';
import { JobUtil } from '@xengage/gw-portals-util-js';

function useActivityUtil(){
    // Common place holder for all dates related calculations useful for grouping activities across all views.

    const getSubject = data => {
     
        let subjectData = '';
        const text = 'for';

        if (data.productName !== undefined && data.productName !== null) {
            subjectData = `${data.subject} ${text} ${onJobClicked(data)} ${text} ${data.accountHolderName}`
            
        } else {
            subjectData = `${data.subject} ${text} ${data.accountNumber} ${data.accountHolderName}`
        }

        return subjectData;
    };

    const onJobClicked = data => {
        let retVal = '';

        if (data.productName && data.policyNumber && !data.jobNumber) {
            retVal =  data.policyNumber;
        } else if ( data.productName && data.jobNumber &&  !JobUtil.isSupportJobType(data.jobType)) {
           retVal = data.jobNumber;
        } else {
           retVal = data.jobNumber;
        }

        return retVal;
    };

    const getNoOfDays = (data) => {
        const currentDate = new Date();
        const eDate = new Date(data.dueDate);
        const noOfDays = currentDate - eDate;
        const noOfDueDay = noOfDays / (1000 * 3600 * 24);

        return Math.floor(noOfDueDay);
    }

    const activitiesCompleteData = data => data.filter(activitiesInfo => activitiesInfo.status === 'complete');


     const activitiesThisWeekAdvanceData = data =>
        data.filter(activitiesInfo => {
            const today = moment();
            const tomorrow = moment().add(1, 'days');
            const endOfWeek = moment().endOf('week');

            return (
                !moment(activitiesInfo.dueDate).isSame(tomorrow, 'd') &&
                !moment(activitiesInfo.dueDate).isSame(today, 'd') &&
                activitiesInfo.status !== 'complete' &&
                moment(activitiesInfo.dueDate).isAfter(tomorrow, 'day') && (!moment(activitiesInfo.dueDate).isAfter(endOfWeek, 'day'))
            );
        });


        const activitiesThisWeekData = (data, status) =>
            data.filter(activitiesInfo => {       
                const tomorrow = moment().add(1, 'days');
                const actMoment = moment();
                const actDueDate = moment(activitiesInfo.dueDate);

                actMoment.set(actDueDate.toObject());
    
                const endOfWeek = moment().endOf('week');

                if (status.includes("unassigned") && status.includes("open")){
                    return ((activitiesInfo.status === 'open' || activitiesInfo.status === 'unassigned') && actMoment.isAfter(tomorrow, 'day') && !(actMoment.isAfter(endOfWeek, 'day')));

                }

                return (activitiesInfo.status === status  && actMoment.isAfter(tomorrow, 'day') && !(actMoment.isAfter(endOfWeek, 'day')));
 
               
            });


    const activitiesTomorrowAdvanceData = data =>
        data.filter(activitiesInfo => {
            const tomorrow = moment().add(1, 'days');

            return (
                activitiesInfo.status !== 'complete' &&
                moment(activitiesInfo.dueDate).isSame(tomorrow, 'd')
            );
        });

          
    const activitiesTomorrowData = (data, status) =>
        data.filter(activitiesInfo => {
            const actMoment = moment();
            const actDueDate = moment(activitiesInfo.dueDate);

            actMoment.set(actDueDate.toObject());

            const tomorrow = moment().add(1, 'days');

            if (status.includes("unassigned") && status.includes("open")){
                return (
                    (activitiesInfo.status === 'open' || activitiesInfo.status === 'unassigned')
                    && actMoment.isSame(tomorrow, 'd')
                );
            }

            return (
                activitiesInfo.status === status  && actMoment.isSame(tomorrow, 'd')
            );
        });


    const activitiesTodayAdvanceData = data =>
        data.filter(activitiesInfo => {
            const today = moment();

            return (
                activitiesInfo.status !== 'complete' &&
                moment(activitiesInfo.dueDate).isSame(today, 'd')
            );
        });


    const activitiesTodayData = (data, status) =>
        data.filter(activitiesInfo => {
            const today = moment();
            const actDueDate = moment(activitiesInfo.dueDate);

            if (status.includes("unassigned") && status.includes("open")){
                return ( activitiesInfo.dueDate !== undefined &&
                    (activitiesInfo.status === 'open' || activitiesInfo.status === 'unassigned') &&
                    actDueDate.isSame(today, 'd')
                );
            }

            return ( activitiesInfo.dueDate !== undefined &&
                activitiesInfo.status === status && 
                actDueDate.isSame(today, 'd')
            );
           
        });

    const activitiesOverdueData = (activityList, status) => {
        const today = moment();
        
        if (status.includes("unassigned") && status.includes("open")){
            return activityList.filter(activity => (
                activity.status !== 'complete'
                &&   (activity.status === 'open' || activity.status === 'unassigned')
                && (_.isUndefined(activity.dueDate) || today.isAfter(activity.dueDate, 'day'))
            ));
        }

        return activityList.filter(activity => (
            activity.status !== 'complete'
            &&   activity.status === status 
            && (_.isUndefined(activity.dueDate) || today.isAfter(activity.dueDate, 'day'))
        ));
    };

    const activitiesOverdueAdvanceData = (activityList) => {
        const today = moment();
        
        return activityList.filter(activity => (
                activity.status !== 'complete' && (_.isUndefined(activity.dueDate) || today.isAfter(activity.dueDate, 'day'))
            ));
    };

    const activitiesFutureAdvanceData = (data) => data.filter(activitiesInfo => {
        const tomorrow = moment().add(1, 'days');
        const actDueDate = moment(activitiesInfo.dueDate);
        const endOfWeek = moment().endOf('week');

       return activitiesInfo.status !== 'complete' && (actDueDate.isAfter(tomorrow, 'day') && (actDueDate.isAfter(endOfWeek, 'day')));
    });

      
    const activitiesFutureData = (data, status) => data.filter(activitiesInfo => {
            const tomorrow = moment().add(1, 'days');
            const actDueDate = moment(activitiesInfo.dueDate);
            const endOfWeek = moment().endOf('week');


            if (status.includes("unassigned") && status.includes("open")){
                return   (activitiesInfo.status === 'open' || activitiesInfo.status === 'unassigned')
                && (actDueDate.isAfter(tomorrow, 'day') && (actDueDate.isAfter(endOfWeek, 'day')));
            }
           
            return   activitiesInfo.status === status && (actDueDate.isAfter(tomorrow, 'day') 
                                            && (actDueDate.isAfter(endOfWeek, 'day')));
        });

   
    const dateFormat = (aDate) => {
        const newDate = moment(aDate);

        return newDate.format('MM/DD/YYYY');
    };

    
    const filterActivitiesByValue = (activityArrayResult, filterValue) => {
        const lowerCaseFilterValue = filterValue.toLocaleLowerCase();
    
        return activityArrayResult.filter(a => a.description?.toString().toLowerCase().includes(lowerCaseFilterValue) 
                || a.subject?.toLowerCase().includes(lowerCaseFilterValue)
                || a.assignedTo?.displayName.toString().toLowerCase().includes(lowerCaseFilterValue)
                || dateFormat(a.dueDate).toString().includes(lowerCaseFilterValue)
                || a.priority.toLowerCase().includes(lowerCaseFilterValue) 
                || getSubject(a).toString().toLowerCase().includes(lowerCaseFilterValue)
            );
            
    };
    

    const filterActivitiesByStatus = (filterValue, statusMap, openActivityData) => {
        let activityList = [];
    
        switch (filterValue) {
            case statusMap.allOpen:
                activityList = openActivityData.filter(
                    act => act.status === 'open' || act.status === 'unassigned'
                );
                break;
            case statusMap.allClose:
                activityList = openActivityData.filter(activitiesInfo => activitiesInfo.status === 'complete');
                break;
            case statusMap.overDueOnly:
                activityList = activitiesOverdueData(openActivityData, 'open');
                break;
            case statusMap.openAssignedToMe:
                activityList = openActivityData.filter(
                    act => act.status === 'open' && act.isAssignedToCurrentUser
                );
                break;
            default:
                break;
        }
    
        return activityList;
    };

    return {
        activitiesOverdueData,
        activitiesOverdueAdvanceData,
        activitiesThisWeekData,
        activitiesThisWeekAdvanceData,
        activitiesTodayData,
        activitiesTodayAdvanceData,
        activitiesTomorrowData,
        activitiesTomorrowAdvanceData,
        activitiesFutureData,
        activitiesFutureAdvanceData,
        activitiesCompleteData,
        dateFormat,
        getNoOfDays,
        filterActivitiesByValue,
        filterActivitiesByStatus
    };
}



export default useActivityUtil;